import { PenNib, Megaphone, MagnifyingGlass, FolderOpen } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";

const POINTS = [
  {
    icon: MagnifyingGlass,
    title: "SEO content writing",
    copy: "Search-focused content written to be read by people first.",
  },
  {
    icon: PenNib,
    title: "Website copy",
    copy: "Clear, practical copy that tells customers exactly why to choose you.",
  },
  {
    icon: Megaphone,
    title: "Digital marketing",
    copy: "Hands-on experience across the channels local businesses actually use.",
  },
];

export const Trust = () => (
  <section
    id="about"
    data-testid="trust-section"
    className="bg-pine-light/40 py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="eyebrow mb-5">Experience</p>
            <p
              data-testid="experience-years"
              className="font-heading text-8xl font-extrabold tracking-tighter text-pine sm:text-9xl"
            >
              15+
            </p>
            <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
              Years of Writing That Talks to Real Customers.
            </h2>
            <p className="mt-6 text-base text-soot sm:text-lg">
              LocalLift is built on more than fifteen years of experience in
              SEO content writing, website copy, and digital marketing. The
              focus has always been the same: practical writing that
              communicates clearly to real customers — not clever agency
              jargon.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
            {POINTS.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.12}>
                <div className="card-surface h-full p-7">
                  <p.icon size={34} weight="duotone" className="text-pine" />
                  <h3 className="mt-5 font-heading text-lg font-bold text-ink">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-soot">{p.copy}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div
              data-testid="case-study-placeholder"
              className="mt-6 flex items-center gap-5 rounded-[2rem] border-2 border-dashed border-pine/30 p-7 sm:p-8"
            >
              <FolderOpen
                size={36}
                weight="duotone"
                className="shrink-0 text-pine"
              />
              <p className="text-sm leading-relaxed text-soot sm:text-base">
                <span className="font-heading font-bold text-ink">
                  Verified case studies and before-and-after examples
                </span>{" "}
                will be published here as clients approve them. Nothing
                invented, nothing inflated.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
